import { IoMdClose } from 'react-icons/io'
import { FaCheck } from 'react-icons/fa'
import { IoIosFlag } from 'react-icons/io'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { GetProgressCourseServices } from '../../services/getProgressCourseServices/GetProgressCourseServices'
import { useContextProyect } from '../../context/ContextProyect'
import '../courseExternal/courseHome.css';
import logsUserService from '../../services/LogsUserActionService'
import LoaderComponent from '../loader/LoaderComponent'

const apiUrl =
  process.env.REACT_APP_STAGE === 'dev'
    ? process.env.REACT_APP_DEV_API_URL
    : process.env.REACT_APP_PROD_API_URL

function CourseHome({ courseId, modules, onClick }) {

  const [porcentageProgress, setPorcentageProgress] = useState();
  const [loadingProgress, setLoadingProgress] = useState(true);
  const { token, idUser } = useAuth();
  const { reloadProgress, setReloadCourse } = useContextProyect();

  useEffect(() => {

    const getPorcentageProgress = async () => {
      setLoadingProgress(true);
      try {
        const dataResponse = await GetProgressCourseServices(token, idUser, courseId);

        if (dataResponse.error) {
          setPorcentageProgress(null);
        } else {
          setPorcentageProgress(dataResponse.data.progress);
        }
      } catch (err) {
        console.error(err)
        setPorcentageProgress(0)
      } finally {
        setLoadingProgress(false)
      }


      setReloadCourse((load) => !load);
    }

    getPorcentageProgress();

  }, [token, idUser, courseId, reloadProgress])

  return (
    <div className='flex items-center justify-stretch grow'>
      <div className='flex flex-col items-start lg:p-20 grow gap-10'>
        {/* Title Section */}
        <h1 className='text-dark-dark-purple text-2xl md:text-5xl font-bold px-[1rem] pt-[1rem] lg:px-0 lg:pt-0'>
          Tu progreso <span className='font-normal'>actual</span>
        </h1>


        {loadingProgress ? (
          <div className='md:w-full relative rounded-md'>
            <div className='flex items-center justify-center h-32'>
              <LoaderComponent />
            </div>
          </div>
        ) : (
          <>
            <div className='bg-[#ffffff] md:w-full relative rounded-md'>
              {/* Description Section */}
              <p className='text-black text-lg mx-4 mt-4 pb-0 mb-2'>
                {Math.floor(porcentageProgress) === 100 ? (
                  <>
                    <span className='font-bold'>¡Felicidades!</span> Has terminado el
                    <span className='font-bold'> {Math.floor(porcentageProgress)}%</span> del curso.
                  </>
                ) : Math.floor(porcentageProgress) >= 25 ? (
                  <>
                    <span className='font-bold'>¡Muy bien!</span> Llevas más del{' '}
                    <span className='font-bold'>{Math.floor(porcentageProgress)}% </span>
                    del curso aprobado.
                  </>
                ) : (
                  <>
                    Llevas <span className='font-bold'>{Math.floor(porcentageProgress)}% </span>
                    del curso aprobado.
                  </>
                )}
              </p>

              {/* Progress Bar Section */}
              <div className='h-6 bg-[#e9ebed] mb-4 mx-4'>
                <div
                  style={{ width: `${Math.floor(porcentageProgress)}%` }}
                  className={`bg-light-green h-6 loader`}
                ></div>
              </div>
              <IoIosFlag className='text-red-700 size-10 absolute top-4 right-2 hidden md:block animate-bounce-flag' />
            </div>
          </>
        )}

        {/* Image Section 245*/}
        <div className='flex justify-center items-center gap-10 mt-2 w-full flex-wrap'>
          {modules &&
            modules.map((module, i) => (
              <button
                className={`rounded-lg overflow-hidden drop-shadow-[0px_0px_5px_#919090] relative ${module.is_available
                  ? 'gradient-card-obesity'
                  : 'cursor-not-allowed'
                  }`}
                key={i}
                onClick={
                  () => {
                    logsUserService(idUser, `Clic en el módulo: ${module.title}`, token);
                    onClick(i)
                  }
                }
                disabled={!module.is_available}
              >
                <img
                  src={apiUrl + module.image_card}
                  alt='Image 1'
                  height={245}
                  width={245}
                  className={`h-[min(245px,100dvw)] w-[min(245px,100dvw)] ${module.is_available
                    ? ''
                    : 'opacity-20 cursor-not-allowed'
                    }`}
                ></img>
                {module.is_checked && (
                  <>
                    <div className='absolute z-10 top-5 left-0 right-0 bg-[#419b36] text-xs py-1 flex justify-start gap-1 pl-3'>
                      Módulo <span className='font-bold'>completado</span>{' '}
                    </div>
                    <div className='absolute z-10 top-3.5 right-3 bg-[#419b36] flex justify-start gap-1 p-2.5 rounded-full'>
                      <FaCheck className='size-4' />
                    </div>
                  </>
                )}

                {!module.is_checked && (
                  <div className='absolute z-10 top-3.5 right-3 bg-light-purple flex justify-start gap-1 p-1.5 rounded-full'>
                    <IoMdClose className='size-6' />
                  </div>
                )}
                <>
                  <div className='absolute z-10 top-14 left-0 right-0 text-xs py-1 flex justify-center gap-1 pl-3'>
                    <img
                      // src={apiUrl + module.image_card}
                      src='/images/icons/Parejita.svg'
                      alt='Image 1'
                      height={245}
                      width={245}
                      className={`h-[min(100px,100dvw)] w-[min(245px,100dvw)] object-contain`}
                      style={{
                        filter: module.is_available
                          ? 'brightness(0.8) saturate(100%) contrast(120%) cursor-not-allowed'
                          : 'invert(82%) sepia(46%) saturate(3291%) hue-rotate(249deg) brightness(99%) contrast(95%)',
                      }}
                    ></img>
                  </div>
                  <div className='absolute z-10 bottom-3 left-0 right-0 text-xs py-1 flex justify-center gap-1 pl-3'>
                    <h5 className={`${module.is_available ? '' : 'text-[#48267f]'}`} >{(() => {
                      const words = module.title.split(" ");
                      if (words.length === 2) {
                        // Dos palabras: una por línea
                        return (
                          <>
                            <span className='font-bold'>{words[0]}</span><br />
                            {words[1]}
                          </>
                        );
                      } else if (words.length > 2) {
                        // Más de dos: primera palabra en línea 1, el resto en línea 2
                        const first = words[0];
                        const rest = words.slice(1).join(" ");
                        return (
                          <>
                            <span className='font-bold'>{first}</span><br />
                            {rest}
                          </>
                        );
                      } else {
                        // Una sola palabra
                        return module.title;
                      }
                    })()}</h5>
                  </div>
                </>
              </button>
            ))}
        </div>

        <div className='w-full flex justify-center'>
          <div className='bg-light-purple flex justify-center items-center mt-2 text-center p-3 lg:rounded-lg w-[min(55rem,100dvw)]'>
            <p className='m-0 max-w-[37rem]'>
              Al momento de
              <span className='font-bold px-1'>aprobar el primer módulo</span>
              progresivamente se irán habilitando los siguientes para lograr
              completar{' '}
              <span className='font-bold px-1'> el 100% del curso.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseHome
